import * as QR from './qr'

export { QR }
